/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@us/app-config';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private readonly env = inject(ENVIRONMENT);
    private readonly httpClient = inject(HttpClient);
    private apiUrl = this.env.apiURL;

    setApiDomain(domain: string | null) {
        if (domain) {
            this.apiUrl = `${domain}/v1`;
        }
    }

    get<T = any>(path: string, options = {}): Observable<T> {
        const url = `${this.apiUrl}/${path}`;
        return this.httpClient.get<T>(url, { responseType: 'json', ...options });
    }

    post<T = any>(path: string, body: any | null, options = {}): Observable<T> {
        const url = `${this.apiUrl}/${path}`;
        return this.httpClient.post<T>(url, body, { responseType: 'json', ...options });
    }

    put<T = any>(path: string, body: any | null, options = {}): Observable<T> {
        const url = `${this.apiUrl}/${path}`;
        return this.httpClient.put<T>(url, body, { responseType: 'json', ...options });
    }

    patch<T = any>(path: string, body: any | null, options = {}): Observable<T> {
        const url = `${this.apiUrl}/${path}`;
        return this.httpClient.patch<T>(url, body, { responseType: 'json', ...options });
    }

    delete<T = any>(path: string, options = {}): Observable<T> {
        const url = `${this.apiUrl}/${path}`;
        return this.httpClient.delete<T>(url, { responseType: 'json', ...options });
    }
}
